import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Css/CheckOut.css';
import CompanyInfoChip from "../Components/CompanyInfoChip";
import icon_search from "../Image/icon_search.png";
import RoomTab from "../Components/RoomTab";
import ViewAllComponent from "../Components/ViewAllComponent";
import deletebtn from "../Image/deletebtn.png";
import retouch from "../Image/retouch.png";
import { toCommaedNumber } from "../DataBind/common"
import { CheckoutedData } from "../DataBind/Checkouted";

const CheckOut = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dicts = CheckoutedData.use(); // 백엔드에서 목록 가져오기
    const sorted = useMemo(()=>{
        if (dicts === null) return null;
        return Object.entries(dicts).sort((a,b) => a[0] > b[1] ? 1 : -1);
    } ,[ dicts ]);

    // 선택된 기업 이름
    const [name, setName] = useState(location.state?.name || null);
    useEffect(()=>{
        setName(name ?? sorted?.[0]?.[0])
    },[sorted])

    // 선택된 기업의 non payments
    /** @type { CheckoutedData[]|null } */
    const target = useMemo(()=>(sorted?.find(item=>item[0] == name)?.[1] || null),[name, sorted])

    // 선택된 기업의 non payments 찍힌 rooms
    /** @type {string[] | null} */
    const rooms = useMemo(()=>{
        if (target === null) return null;
        const result = new Set();
        for (const checkoutPayment of target) {
            result.add(+checkoutPayment.room)
        }
        return [...result].sort();
    }, [ target ])

    const [selectedRoom, setSelectedRoom] = useState(null);
    useEffect(()=>{
        if (rooms === null) return;
        setSelectedRoom(rooms[0]);
    }, [ rooms ])

    /** @type { [string,CheckoutedData[]][]|null } */
    const roomPaymentsYearSorted = useMemo(()=>{
        if (target === null) return null;
        return Object.entries(
            target
                .filter(item => item.room == selectedRoom)
                .reduce((years, item)=>{
                    if (item?.createTime)
                        (years[item.createTime.year] ??= []).push(item);
                    return years;
                },{})
        ).sort((a,b)=>b[0] - a[0]).map(year => year.sort((a,b) => -a.createTime?.compare(b.createTime)));
    }, [ target, selectedRoom ]);
    /** @type { CheckoutedData|null } */
    const roomFirstPayment = useMemo(()=>{
        if (roomPaymentsYearSorted === null) return null;
        const year = roomPaymentsYearSorted?.[roomPaymentsYearSorted.length-1]?.[1]
        return year?.[year?.length - 1];
    },[ roomPaymentsYearSorted ])
    // /** @type { CheckoutedData|null } */
    // const roomLastPayment = useMemo(()=>{
    //     if (roomPaymentsYearSorted === null) return null;
    //     return roomPaymentsYearSorted?.[0]?.[1]?.[0];
    // },[ roomPaymentsYearSorted ])

    const nextRoom = useCallback(()=>setName(current =>
        sorted[(sorted.findIndex(item=>item[0] == current)-1+sorted.length)%sorted.length]?.[0]
    ),[sorted]);
    const prevRoom = useCallback(()=>setName(current =>
        sorted[(sorted.findIndex(item=>item[0] == current)+1+sorted.length)%sorted.length]?.[0]
    ),[sorted])

    // const handleBackClick = () => {
    //     // navigate(-1); // 이전 페이지로 이동
    // };

    // const handleChipClick = (chipName) => {
    //     setName(chipName); // 선택한 회사 이름으로 상태 업데이트
    // };

    const [search, setSearch] = useState("");
    const searchChange = useCallback((event)=>{
        setSearch(event.target.value.toLowerCase()); // 검색어 업데이트
    }, []);
    const companySearchFiltered = useMemo(
        ()=>(search == '' ? sorted : sorted?.filter(item => item[0].toLowerCase().includes(search))),
        [ search, sorted ]
    );

    return (

        <div className="registration-container">
            <div className="registration-middle-container">

                {/* 사이드바 */}
                <div className="registration-sidebar">
                    <div className="search">
                        <img className="icon_search" src={icon_search} alt="See more"/>
                        <input
                            className="search-bar"
                            placeholder="업체명을 입력하세요"
                            onChange={searchChange}
                        />
                    </div>

                    {/* Chip 컴포넌트 */}
                    {companySearchFiltered?.map(([company]) => (
                        <CompanyInfoChip
                            key={company}
                            name={company}
                            onClick={() => setName(company)}
                        />
                    ))}
                </div>

                {/* 메인 박스 */}
                <div className="see-all-mainbox">
                    {/* <div className="see-all-back-btn" onClick={()=>navigate(-1)}>
                        목록 보기
                    </div> */}
                    <div className="see-all-next-btn" onClick={nextRoom}>
                        이전 기업
                    </div>
                    <div className="see-all-view-list-btn" onClick={prevRoom}>
                        다음 기업
                    </div>
                    <div className="see-all-mainbox-left">
                        {/* 회사 정보 박스 */}
                        <div className="see-all-company-titlebox">
                            {/* <img className="see-all-retouch-company-btn" src={retouch}
                                 alt="See more"/> */}

                            <div className="payment-company-name">{name}

                            </div>
                            <div className="payment-company-info-box">
                                <div className="payment-company-info-innerbox">
                                    {/* <div className="payment-info-cap">대표자 : {target?.boss}</div> */}
                                    <div className="payment-info-use-room" style={{ marginLeft: "24px", marginBottom: "24px" }}>입주 호실 : {rooms?.map(room => `${room}호`)?.join(", ")}</div>
                                </div>
                                {/* vv 데이터가 없기 때문에 표시가 불가능합니다. vv*/}
                                {/* <div className="payment-info-box"> */}
                                    {/* <div className="payment-info">보증금 : ₩ {toCommaedNumber(target?.deposit)}</div> */}
                                    {/* <div className="payment-info-1">사업자번호 : {target?.certificateRegistration}</div> */}
                                    {/* <div className="payment-info-1">전화번호 : {target?.phone}</div> */}
                                {/* </div> */}
                            </div>
                        </div>
                        <div className="view-all-text">전체내역</div>
                        <div className="see-all-box">
                            <RoomTab rooms={rooms ?? []} onSelect={setSelectedRoom} selectedRoom={selectedRoom}/>
                            <div className="payment-info-use-room" style={{marginLeft: "24px"}}>
                                {`입주일자 : ${
                                    roomFirstPayment?.createTime?.toText()
                                } 퇴거일자 : ${
                                    roomPaymentsYearSorted?.[0]?.[1]?.[0]?.checkoutDate?.toText() ?? "데이터 없음"
                                }`}</div>
                            {roomPaymentsYearSorted?.map(year =>
                                <ViewAllComponent key={year[0]} year={year[0]} data={year[1]}/>
                            )}
                            {/* <ViewAllComponent years={2024}/>
                            <ViewAllComponent years={2023}/>
                            <ViewAllComponent years={2022}/> */}
                        </div>
                        <div className={'a'}>.</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckOut;
